import React from "react";
import AnonymousProfilePicture from "@irati/ui/src/ProfilePicture/AnonymousProfilePicture";
import id from "@irati/utils/id";
import { H3 } from "@irati/ui/src/Typography";
var LoginPicAndHeader = function (_a) {
    var name = _a.name, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(AnonymousProfilePicture, { id: id("profile-pic", name) }),
        React.createElement(H3, { id: id("card-title", name), marginBottom: 4 }, children)));
};
export default LoginPicAndHeader;
